// src/app/features/payments/checkout/components/sections/TotalSection.tsx
import { motion } from "motion/react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface TotalSectionProps {
  formattedBaseTotal: string;
  formattedReferralDiscount: string | null;
  referralDiscountPercent: number;
  formattedPromoDiscount: string | null;
  formattedTotal: string;
}

export function TotalSection({
  formattedBaseTotal,
  formattedReferralDiscount,
  referralDiscountPercent,
  formattedPromoDiscount,
  formattedTotal,
}: TotalSectionProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="mb-6 rounded-2xl border border-white/20 dark:border-white/20 bg-white/5 dark:bg-white/5 backdrop-blur-sm p-6 shadow-sm"
    >
      <h2 className="mb-4 text-sm font-semibold uppercase tracking-wide text-muted-foreground">{t('total')}</h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>{t('subtotal')}</span>
          <span>{formattedBaseTotal}</span>
        </div>
        {formattedReferralDiscount && (
          <div className="flex items-center justify-between text-sm text-green-600 dark:text-green-400">
            <span>{t('referralDiscount')} {referralDiscountPercent}%</span>
            <span>-{formattedReferralDiscount}</span>
          </div>
        )}
        {formattedPromoDiscount && (
          <div className="flex items-center justify-between text-sm text-green-600 dark:text-green-400">
            <span>{t('promoDiscount')}</span>
            <span>-{formattedPromoDiscount}</span>
          </div>
        )}
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-border pt-4">
        <span className="text-lg font-bold text-foreground">{t('toPay')}</span>
        <span className="text-2xl font-bold text-violet-600">{formattedTotal}</span>
      </div>
    </motion.div>
  );
}